
export const config = {
    platformTitle: "NewHomeZ",
    platformPhoneNumber: "+16476490400",
    platformWhatsAppNumber: "16476490400", //Always without plus sign 
}